// extracted by mini-css-extract-plugin
export var dropdown = "_so-0";
export var imageWrapper = "_so-3";
export var itemNameContainer = "_so-1";
export var productImage = "_so-2";
export var spinnerWrapper = "_so-4";